export default __webpack_public_path__ + "4309ab89c2573a0af7554c6d8b6b338d.webp";